import { useEffect } from 'react';

/**
 * Métadonnées SEO de la page courante.
 *
 * Historique : ce composant s'appuyait sur react-helmet-async, qui ne
 * s'appliquait en réalité JAMAIS (vérifié en production le 09/08/2026 :
 * /about, /login… affichaient tous le titre et le canonical de l'accueil,
 * donc Google voyait toutes les pages comme des doublons de la home).
 * On écrit désormais directement dans le <head>, sans dépendance : c'est
 * plus simple et surtout ça fonctionne.
 *
 * Toutes les balises gérées ici sont marquées data-seo pour être remplacées
 * proprement d'une page à l'autre.
 */

const setMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    el.setAttribute('data-seo', 'true');
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    el.setAttribute('data-seo', 'true');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

export default function SEO({
  title = 'Joyful Reveal - Jeu Gender Reveal | Mirum Games',
  description = 'Joyful Reveal, le jeu de gender reveal party : quiz en équipes, puzzle à assembler et pièce finale à gratter qui révèle le sexe de bébé.',
  image = '/og-image.jpg',
  url = '',
  type = 'website',
  keywords = 'gender reveal, jeu gender reveal, puzzle révélation sexe bébé, gender reveal party, cadeau grossesse',
  noindex = false,
}) {
  const baseUrl = 'https://www.mirumgames.com';
  const fullUrl = url ? `${baseUrl}${url}` : baseUrl;
  const fullTitle = title.includes('Mirum Games') ? title : `${title} - Mirum Games`;
  const fullImage = `${baseUrl}${image}`;

  useEffect(() => {
    document.title = fullTitle;

    setMeta('name', 'description', description);
    setMeta('name', 'keywords', keywords);
    // Toujours explicite : sinon une page noindex « contaminerait » la suivante.
    setMeta('name', 'robots', noindex ? 'noindex, follow' : 'index, follow');
    setCanonical(fullUrl);

    setMeta('property', 'og:type', type);
    setMeta('property', 'og:title', fullTitle);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:image', fullImage);
    setMeta('property', 'og:url', fullUrl);
    setMeta('property', 'og:site_name', 'Mirum Games');

    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', fullTitle);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:image', fullImage);
  }, [fullTitle, description, keywords, noindex, fullUrl, type, fullImage]);

  return null;
}
